var map = {
	"./black/top.png": "eg9H",
	"./blue/top.png": "9S13",
	"./white/top.png": "djPG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PsIb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/top\.png$
// module id = PsIb
// module chunks = 24